<template>
    <drop-down 
        :label="!estrangeiro ? 'Região/Distrito' : 'Região'" 
        :options="regions" 
        v-model="value.region" 
        :native="true"
        @change="change"
    />
    <drop-down 
        :label="!estrangeiro ? 'Concelho' : 'País'" 
        :options="districts" 
        v-model="value.district" 
        :native="true"
        @change="change"
    />
    <drop-down 
        :label="!estrangeiro ? 'Freguesia' : 'Consulado'" 
        :options="places" 
        v-model="value.place" 
        :native="true"
        @change="change"
    />
</template>

<script>
import { sort } from '@/core/utils'
import map from '@/core/map'
export default {
    props: {
        estrangeiro: Boolean
    },
    data: () => ({
        value: {},
        dealy: null,
        portugal: 'Território Nacional'
    }),
    beforeMount() {
        if(this.active) this.value = {
            ...this.active
        }
    },
    methods: {
        valid(code) {
            if(!code) return;
            const value = `${code}`;
            if(value.length != 6) return;
            const char = parseInt(value.charAt(0));
            return char != 5 ? (!this.estrangeiro ? (!char || char < 5) : (char > 5)) : false;
        },
        change(res) {
            if(!res || !res.value || res.value == this.$state.local || (!this.valid(res.value) && res.value != '500000')) return;
            this.$state.local = res.value;
        },
        region(code) {
            return !this.valid(code) ? null : !parseInt(`${code}`.substr(2, 4));
        },
        district(code) {
            return !this.valid(code) ? null : (!this.region(code) && !this.place(code));
        },
        place(code) {
            return !this.valid(code) ? null : !`${code}`.endsWith('00');
        },
        update() {
            const active = {
                ...(this.active || {})
            };
            ['region', 'place', 'district'].forEach(item => {
                const value = active[item] || 0;
                if(this.value[item] != value) this.value[item] = value;
            });
        },
        build() {
            clearTimeout(this.delay);
            this.delay = setTimeout(this.update, 1);
        }
    },
    computed: {
        char() {
            return !this.$state.local ? 0 : parseInt(`${this.$state.local}`.charAt(0));
        },
        active() {
            if(!this.$state.local) return;
            let res = {}
            res.place = `${this.$state.local}`;
            res.region = `${this.char}${![5,6,8,9].includes(this.char) ? res.place.charAt(1) : '0'}0000`;
            res.district = `${res.place.slice(0, 4)}00`;
            if(res.district.endsWith('0000')) delete res.district;
            if(res.place.endsWith('00')) delete res.place;
            let data = {};
            for(let key in res) {
                const value = res[key];
                if(map.locals[value]) data[key] = {
                    title: map.locals[value].title,
                    value
                };
            }
            return data;
        },
        regions() {
            let res = [];
            for(let value in map.codes) this.region(value) && res.push({
                title: map.codes[value].title,
                value
            });
            let data = sort(res, 'title');
            !this.estrangeiro && data.unshift({
                title: this.portugal,
                value: '500000'
            });
            return data;
        },
        districts() {
            let res = [];
            for(let value in map.locals) if(this.district(value)) {
                ([5,6].includes(this.char) || `${value}`.startsWith(`${this.char}${!this.estrangeiro && ![3,4].includes(this.char) ? `${this.$state.local}`.charAt(1) : ''}`)) && res.push({
                    title: map.locals[value].title,
                    value
                });
            }
            let data = sort(res, 'title');
            ![5,6].includes(this.char) && parseInt(`${this.$state.local}`.slice(2, 4)) && data.unshift({
                title: `Todos os ${!this.estrangeiro ? 'concelhos' : 'países'}`,
                value: `${this.char}${!this.estrangeiro ? `${this.$state.local}`.charAt(1) : `0`}0000`
            });
            return data;
        },
        places() {
            let res = [];
            for(let value in map.locals) if(this.place(value)) {
                let pass = !this.district(this.$state.local) && !this.place(this.$state.local) ? `${this.char}${(!this.estrangeiro && ![3,4].includes(this.char) ? `${this.$state.local}`.charAt(1) : '' )}` : `${this.$state.local}`.slice(0, 4);
                ([5,6].includes(this.char) || `${value}`.startsWith(pass)) && res.push({
                    title: map.locals[value].title,
                    value
                });
            }
            let data = sort(res, 'title');
            const val = !this.estrangeiro ? 'a' : 'o';
            ![5,6].includes(this.char) && parseInt(`${this.$state.local}`.slice(4, 6)) && data.unshift({
                title: `Tod${val}s ${val}s ${!this.estrangeiro ? 'freguesias' : 'consulados'}`,
                value: `${`${this.$state.local}`.slice(0, 4)}00`
            });
            return data;
        },
        title() {
            return this.char > 5 ? 'Estrangeiro' : this.portugal;
        }
    },
    watch: {
        '$state.local': {
            immediate: true,
            handler() {
                this.build();
            }
        },
        active: {
            immediate: true,
            deep: true,
            handler() {
                this.build();
            }
        }
    },
    beforeUnmount() {
        clearTimeout(this.delay);
    }
}
</script>

<style lang="scss" scoped>
button.reset {
    display: block;
    width: 200px;
    margin: 0 auto;
    color: var(--base-link);
    margin-bottom: 1rem;
    text-align: center;
    height: 32px;
    line-height: 32px;
    svg {
        margin-right: .5rem;
        height: 20px;
        margin-bottom: -4px;
    }
}
</style>